<template>
  <div class="il-connect-adapter">
    <o-t-s-credentials-connection
      v-if="currentStep === steps.CREDS_CONNECTION"
      :title="widget.title"
      :subtitle="widget.subtitle"
      :background-color="widget.backgroundColor"
      :is-visible="isVisible"
      @nextPage="onNextPage" />
    <o-t-s-missing-cards-connection
      v-else-if="currentStep === steps.MISSING_CARDS_CONNECTION" />
    <preparing-o-t-s v-else-if="currentStep === steps.PREPARING_OTS" @finishedLoadingCashflow="onFinishedLoadingCashflow" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import OTSCredentialsConnection from '@/pages/responsive-pages/authenticated/onboard2/OTSCredentialsConnection.vue';
import PreparingOTS from '@/pages/responsive-pages/authenticated/onboard2/steps/PreparingOTS.vue';
import OTSMissingCardsConnection from '@/pages/responsive-pages/authenticated/onboard2/OTSMissingCardsConnection.vue';
import Segment from '@/Segment';
import moment from 'moment';
import router from '@/router';

const steps = {
  CREDS_CONNECTION: 'CREDS_CONNECTION',
  MISSING_CARDS_CONNECTION: 'MISSING_CARDS_CONNECTION',
  PREPARING_OTS: 'PREPARING_OTS',
};

export default {
  name: 'IlConnectStoryLibAdapter',
  components: {
    PreparingOTS,
    OTSCredentialsConnection,
    OTSMissingCardsConnection,
  },
  props: {
    widget: {
      type: Object,
      required: true,
    },
    analyticsPrefix: {
      type: String,
      default: '',
    },
    extraParams: {
      type: Object,
      default: () => ({}),
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      financialProfileScore: null,
      currentStep: steps.CREDS_CONNECTION,
    };
  },
  async created() {
    Segment.trackUserGot(`${this.analyticsPrefix}_OnBoardingFlowEntered`, {
    });
    await this.fetchCredentialsSettings();

    if (!this.hasValidCreds) {
      if (this.lowFinancialProfile) {
        this.currentStep = steps.MISSING_CARDS_CONNECTION;
      }
      this.currentStep = steps.CREDS_CONNECTION;
    }
  },
  computed: {
    ...mapState('ots', ['otsFlowConfig']),
    ...mapState('websocket', ['socketMessage']),
    ...mapGetters('credentialsNew', ['hasValidCreds']),
    ...mapGetters('credentials', ['latestScrapedAt']),
    ...mapState('otsState', ['otsState']),
    ...mapGetters('otsState', ['isInOtsFlow']),
    shouldTriggerScrape() {
      return !this.latestScrapedAt || moment().diff(this.latestScrapedAt, 'days') >= 3;
    },
    steps() {
      return steps;
    },
    lowFinancialProfile() {
      return this.financialProfileScore && this.financialProfileScore.connectedPercentage < 80;
    },
  },
  methods: {
    ...mapActions('credentialsNew', ['fetchCredentialsSettings']),
    ...mapActions('otsState', ['updateOtsState']),
    async onFinishedLoadingCashflow() {
      await this.updateOtsState({ flowId: this.otsFlowConfig.flowId, otsPhase: 'results', pageIndex: 0 });
      if (this.otsFlowConfig && this.otsFlowConfig.resultsPageFlow) {
        if (this.otsFlowConfig.resultsPageFlow.pageType === 'url') {
          await router.push({ path: this.otsFlowConfig.resultsPageFlow.flowId, query: this.$route.query });
        } else {
          await router.push({ path: '/ots/results', query: this.$route.query });
        }
      }
    },
    onNextPage() {
      this.currentStep = steps.PREPARING_OTS;
    },
  },
  watch: {
    async socketMessage() {
      await this.fetchCredentialsSettings();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/mixins.scss';

.full-height {
  height: 100%;
}
</style>
